import validateAccount from '../validator/validateAccount'
import validatePassword from '../validator/validatePassword'
import validateMobile from '../validator/validateMobile'

export default {
  account: [{ required: true, trigger: 'blur', validator: validateAccount }],
  password: [{ required: true, trigger: 'blur', validator: validatePassword }],
  oldPassword: [
    { required: true, trigger: 'blur', validator: validatePassword },
  ],
  newPassword: [
    { required: true, trigger: 'blur', validator: validatePassword },
  ],
  confirmPassword: [
    { required: true, trigger: 'blur', message: '确认密码不能为空' },
  ],
  mobile: [{ required: true, trigger: 'blur', validator: validateMobile }],
  random: [{ required: true, trigger: 'blur', message: '短信验证码不能为空' }],
}
